import { usePublicApplication } from '../../../../../hooks/usePublicApplication';
import useOrderBookStore from '../../../../../stores/OrderBook/orderBook.store';
import useIsAdminSeller from '../../../../../stores/ShowUnavailableProducts/hooks/useIsAdminSeller';
import { returnOrderIdBasedOnPublicOrder } from '../../../../../utils/returnOrderIdBasedOnPublicOrder';
import { CatalogListContextParams } from '../catalogProductsListV2.types';

export const useCatalogListContextParams = (): CatalogListContextParams => {
  const selectedOrder = useOrderBookStore((store) => store.selectedOrder);
  const { sharedEntity } = usePublicApplication();
  const isAdminSeller = useIsAdminSeller();

  const orderId = returnOrderIdBasedOnPublicOrder(sharedEntity, selectedOrder?.id);

  return {
    order: { position: 'ASC' },
    active: true,
    isAdminSeller,
    orderId,
  };
};
